import axios from 'axios'
import qs from 'qs';
import { v4 as uuidv4 } from 'uuid'
import { PendingUser } from '@/lib/class/PendingUser'
import { getCurrentEnvironment } from '@/mixins/utils'
import TagManager from '@/sdk/careshipTracking/src/gtm'
import { createUserAccount } from '@/sdk/clients/AccountClient'
import {
  matchCaregiverProfiles,
  matchCaregiversByPostcode,
  submitPostcode,
} from '@/sdk/clients/MatchClient'
import {
  addPostcodeToServiceRequestDraft,
  createServiceRequestDraft,
} from '@/sdk/clients/ServicesRequest'
import logger from '@/sdk/logger'
import { getAndSaveUserToken } from '@/sdk/oauth'
import store from '@/store'
import getUnixTime from 'date-fns/getUnixTime'
import {decryptData, hashData} from "@/plugins/crypto";

export default {
  getCaregiversIds({ commit }, payload) {
    return new Promise(async resolve => {
      const response = await submitPostcode(payload)

      if (response instanceof Error) {
        commit('setCaregiversIds')
        commit('setNumberOfCaregivers')
        return resolve(false)
      }

      const caregiversIds = response.caregiver_ids

      commit('setCaregiversIds', caregiversIds)
      commit('setNumberOfCaregivers', response.count)

      resolve(caregiversIds)
    })
  },

  async getCaregiversCards({ commit, getters }) {
    const payloadCaregiversIds = getters.caregiversIds()
    const caregivers = await matchCaregiverProfiles(payloadCaregiversIds)
    commit('setCaregiversCards', caregivers)
  },

  async getCaregiversListByPostcode({ commit }, postcode) {
    const caregivers = await matchCaregiversByPostcode(postcode)

    commit('setCaregiversListByPostcode', caregivers)
  },

  // Data used for navigation header in Frontend, LP and WP
  setSRDraftDataInLocalStorage({ state }) {
    const serviceRequestDraftData = {
      createdAt: getUnixTime(new Date()),
      id: state.serviceRequestDraftId,
      src: 'careship-frontend',
      status: 'pending',
      version: 1,
    }

    localStorage.setItem(
      'serviceRequestDraftData',
      JSON.stringify(serviceRequestDraftData),
    )
  },

  removeSRDraftDataFromLocalStorage() {
    localStorage.removeItem('serviceRequestDraftData')
  },

  async registerWithRandomEmailAndPassword() {
    await store.dispatch('registration/register', {
      email: `playground+fakeSR-${uuidv4()}@careship.de`,
      firstName: 'na',
      gender: '',
      lastName: 'na',
      password: uuidv4(),
      utmTerm: sessionStorage.getItem('utm_term'),
      utmContent: sessionStorage.getItem('utm_content'),
      utmMedium: sessionStorage.getItem('utm_medium'),
      utmSource: sessionStorage.getItem('utm_source'),
      utmCampaign: sessionStorage.getItem('utm_campaign'),
      utmCampaigns: sessionStorage.getItem('utm_campaigns'),
      gclid: sessionStorage.getItem('gclid'),
    })
  },

  async zapierCuBooking(user) {
    const newLead = user.state.customerLead
    const uri = 'https://hooks.zapier.com/hooks/catch/913207/33liujj/' //Production
    //const uri = 'https://hooks.zapier.com/hooks/catch/913207/36jmkbs/' //Staging
    const customerLeadData = {
      firstName: newLead.firstName,
      lastName: newLead.lastName,
      phone: newLead.phone,
      email: newLead.email,
      startDate: newLead.startDate || '',
      description: newLead.description,
      time: newLead.time || '',
      services: newLead.services,
      mainServices: newLead.mainServices,
      secondaryServices: newLead.secondaryServices,
      utmTerm: sessionStorage.getItem('utm_term'),
      utmContent: sessionStorage.getItem('utm_content'),
      utmMedium: sessionStorage.getItem('utm_medium'),
      utmSource: sessionStorage.getItem('utm_source'),
      utmCampaign: sessionStorage.getItem('utm_campaign'),
      utmCampaigns: sessionStorage.getItem('utm_campaigns'),
      gclid: sessionStorage.getItem('gclid'),
      zipCode: newLead.zipCode
    }
    try {
      await fetch(uri, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        body: JSON.stringify(customerLeadData),
      })
    } catch (error) {
      throw new Error(error)
    }
  },
  async zapierReactivateC(user) {
    const newLead = user.state.reactivateCC
    const uri = 'https://hooks.zapier.com/hooks/catch/913207/3t2jz2e/'
    const reactivateCCData = {
      ContactId: newLead.ContactId,
      email: newLead.email,
      Lostreason: newLead.Lostreason,
      Improvements: newLead.Improvements,
    }
    try {
      await fetch(uri, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        body: JSON.stringify(reactivateCCData),
      })
    } catch (error) {
      throw new Error(error)
    }
  },
  async zapierFeedback(user) {
    const newLead = user.state.reactivateCC
    const uri = 'https://hooks.zapier.com/hooks/catch/913207/3mrux9t/'
    const reactivateCCData = {
      ContactId: newLead.ContactID,
      Feedback: newLead.Feedback,
    }
    try {
      await fetch(uri, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        body: JSON.stringify(reactivateCCData),
      })
    } catch (error) {
      throw new Error(error)
    }
  },
  async zapierConfirmA1(user) {
    const newLead = user.state.reactivateCC
    const uri = 'https://hooks.zapier.com/hooks/catch/913207/3mr9swm/'
    const reactivateCCData = {
      ContactId: newLead.ContactID,
      Comment: newLead.Comment,
    }
    try {
      await fetch(uri, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        body: JSON.stringify(reactivateCCData),
      })
    } catch (error) {
      throw new Error(error)
    }
  },
  async zapierNewCGFunel(user) {
    const newLead = user.state.newCustomer
    //const uri = 'https://hooks.zapier.com/hooks/catch/913207/3wq5pwq/' //Staging URL
    const uri = 'https://hooks.zapier.com/hooks/catch/913207/3fjuac6/' //Production URL
    const newCaregiverData = {
      FirstName: newLead.firstName,
      LastName: newLead.lastName,
      Email: newLead.email,
      PhoneNumber: newLead.phone,
      PostalCode: newLead.postcode,
      Company: newLead.company,
      City: newLead.city,
      Frontend_uuid__c: newLead.frontend_uuid,
      Frontend_uuid_hash__c: newLead.frontend_uuid_hash,
      Terms_and_conditions : true,

      utmTerm: sessionStorage.getItem('utm_term'),
      utmContent: sessionStorage.getItem('utm_content'),
      utmMedium: sessionStorage.getItem('utm_medium'),
      utmSource: sessionStorage.getItem('utm_source'),
      utmCampaign: sessionStorage.getItem('utm_campaign'),
      utmCampaigns: sessionStorage.getItem('utm_campaigns'),
      gclid: sessionStorage.getItem('gclid'),
    }
    console.log(newCaregiverData)
    try {
      await fetch(uri, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        body: JSON.stringify(newCaregiverData),
      })
    } catch (error) {
      throw new Error(error)
    }
  },

  async zapier2ndLongCUFunel(user) {
    const newLead = user.state.newCustomer
    const customerInfo = user.state.customerInfo
    //const uri = 'https://hooks.zapier.com/hooks/catch/913207/3wq5nxw/'  //Staging URL

    const frontend_uuid_storage = sessionStorage.getItem('__f')
    const frontend_uuid =
      customerInfo.frontend_uuid ||
      newLead.frontend_uuid ||
      frontend_uuid_storage ||
      hashData(newLead.email)

    const uri = 'https://hooks.zapier.com/hooks/catch/913207/3fjuwqm/ ' //Production URL
    const newCaregiverData = {
      Email: newLead.email,

      Anrede: customerInfo.salutation,
      DateOfBirth: customerInfo.dateOfBirth,
      Address: customerInfo.address,

      Residence: customerInfo.residence,
      Kannst_Du_im_weiteren_Bewerbungsprozess : customerInfo.conduct,
      Wie_schätzt_Du_Deine_Sprachkenntnisse_in_Deutsch_ein: customerInfo.languageSkills,
      Welche_weiteren_Sprachen_sprichst_du_fließend_oder_besser: customerInfo.otherLanguageSkills,
      Welche_Bildungsabschlüsse_hast_du: customerInfo.education,
      Bitte_wähle_hier_die_Fachrichtungen: customerInfo.educationField,
      Mein_gegenwärtiger_Arbeitsstatus_lautet: customerInfo.workStatus,
      In_welchem_Bundesland_möchtest_du_Alltagshilfe_leisten: customerInfo.workLocation,

      Für_wie_lange_hast_Du_vor_mit_Careship_zusammenzuarbeiten: customerInfo.berlinOption,
      Kleingewerbe: customerInfo.noBerlinOption1,
      Wie_viele_Wochenstunden_hast_Du_vor : customerInfo.noBerlinOption2,

      Für_wie_lange_hast_Du_vor : customerInfo.workDuration,
      Was_beschreibt_Deine_Motivation_als_Alltagshilfe_zu_arbeiten_am_besten: customerInfo.workMotivation,
      Wurde_Dir_Careship_von_einer_anderen_Alltagshilfe_empfohlen: customerInfo.workRecommandation,
      Welche_Alltagshilfe_hat_Dich_für_Careship_angeworben: customerInfo.wordRecruter,
      Terms_and_conditions : true,
      Is_Eu_Resident: customerInfo.isEuResident,
      Frontend_uuid: frontend_uuid,

      utmTerm: sessionStorage.getItem('utm_term'),
      utmContent: sessionStorage.getItem('utm_content'),
      utmMedium: sessionStorage.getItem('utm_medium'),
      utmSource: sessionStorage.getItem('utm_source'),
      utmCampaign: sessionStorage.getItem('utm_campaign'),
      utmCampaigns: sessionStorage.getItem('utm_campaigns'),
      gclid: sessionStorage.getItem('gclid'),
    }
    try {
      await fetch(uri, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        body: JSON.stringify(newCaregiverData),
      })
    } catch (error) {
      throw new Error(error)
    }
  },

  async register({ commit, state }, user) {
    await store.dispatch('auth/deleteAuth')

    const pendingUser = new PendingUser(user)

    /**
     * Try to create a user, then save that new user's customerId
     */

    const newCustomerId = await createUserAccount(pendingUser.payload)

    sessionStorage.removeItem('registerUser')

    /**
     * We save the new customer's ID to sessionStorage so the QA Automation can pick it up
     * to “fake” the email validation.
     *
     * Please see the COPS-49 ticket for more information.
     * @link https://careship.atlassian.net/browse/COPS-49
     */
    if (getCurrentEnvironment() === 'staging') {
      sessionStorage.setItem('customerId', newCustomerId)
    }

    /**
     * Delete any Care Receiver that might have been created before in the current app session.
     */

    await store.dispatch(
      'carereceiver/setCareReceiverIdForCurrentBookingFunnel',
      null,
    )

    /**
     * getAndSaveUserToken here essentially is used to “login” this new user
     */
    const loggedIn = await getAndSaveUserToken(
      pendingUser.email,
      pendingUser.password,
    )

    if (loggedIn === false) {
      // @TODO: handle this edge case
      const error = new Error('USER_LOG_IN_FAILED')

      logger.error('failed fetching the user token', {
        error,
        tags: ['registration', 'http', 'user', 'userToken'],
      })

      throw error
    }

    /**
     * Track registration in GTM.
     */

    const gtm = new TagManager()
    const numberOfCaregivers =
      state.numberOfCaregivers ||
      state.caregiversListByPostcode.caregivers.length

    if (pendingUser.email.indexOf('@careship.de') === -1) {
      gtm.trackEvent({
        category: 'registration',
        action: `successful registration${
          numberOfCaregivers === 0 ? ' without caregivers found' : ''
        }`,
        label: 'without newsletter opt-in',
      })
    }

    /**
     * If there are no caregivers in the area, we return false because the components is
     * “waiting” for a value for draftCreated → therefore redirecting to the “thank you” page
     * instead of the booking funnel.
     */

    if (numberOfCaregivers === 0) {
      return false
    }

    /**
     * Create a SR Draft for this new user, so users always have a Draft.
     */
    let newDraft

    try {
      newDraft = await createServiceRequestDraft(newCustomerId)
    } catch (error) {
      return false
    }

    commit('setServiceRequestDraftId', newDraft.process_id)

    /**
     * Update the local user details.
     */
    try {
      await store.dispatch('user/getUserDetails')
    } catch (error) {
      logger.error('failed getting the user details', {
        error,
        tags: ['registration', 'http', 'user', 'userDetails'],
      })

      return false
    }

    /**
     * We need to push the postcode to the new SRD.
     */
    try {
      const postcode = store.getters['postcode/postcode']

      await addPostcodeToServiceRequestDraft(newDraft.process_id, postcode)
    } catch (error) {
      return false
    }

    /**
     * Notify the component the process was successful.
     */

    return true
  },
}
